import { icon } from "@conectate/components/icon-list.js";

import { strings } from "../../../@strings/strings.js";
import { MGST } from "./mg.schema-types.js";
import { TestQuestion } from "./mg.schema.js";
import { PGSchema } from "./pg.schema.js";

export namespace PGST {
	export namespace hcm_attendances {
		export enum types {
			WORK = "work",
			BREAK = "break",
			LUNCH = "lunch",
			OTHER = "other"
		}
		export enum modes {
			MANUAL = "manual",
			REALTIME = "realtime",
			EDITED = "edited"
		}
	}
	export namespace faqs {
		export interface i18n {
			lang: string;
			slug: string;
			title: string;
			short: string;
			content?: string;
		}
	}

	export namespace faqs_categories {
		export interface i18n {
			lang: string;
			slug: string;
			title: string;
			description: string;
		}
	}

	export namespace blog {
		export interface i18n {
			lang: string;
			slug: string;
			title: string;
			descrip: string;
			content: string;
			tags?: string[];
			qa?: {
				question: string;
				answer: string;
			}[];
		}
	}

	export namespace blog_categories {
		export interface i18n {
			lang: string;
			name: string;
		}
	}
	export namespace users {
		export enum driver_lic {
			c_automóviles = 0,
			a_vehiculos_pesados = 1,
			e_industrial_carl = 3,
			b_ = 4,
			m_bikes = 5
		}

		export enum insignia {
			PROFILE_COMPLETE = 0,
			CAPACITADO = 1
		}
		export namespace emails {
			export enum type {
				PERSONAL = 0,
				WORK = 1
			}
		}

		export enum referrer_media {
			"Amigos" = "amigos",
			"Radio" = "radio",
			"Television" = "tv",
			"RedesSociales" = "redes",
			"MediosEscritos" = "prensa",
			"Internet" = "internet",
			"Rotulos" = "rotulo",
			"ConferenciasEventos" = "conf",
			"n_a" = "n/a"
		}

		export enum studies {
			"Primaria" = 0,
			"Basicos" = 1,
			"Diversificado" = 2,
			"Estudiante Universitario" = 3,
			"GradoLicenciatura" = 4,
			"MasterPostgrado" = 5
		}

		export enum civil_status_id {
			OTHER = -1,
			SOLERO = 0,
			CASADO = 1,
			DIVORCIADO = 2,
			VIUDO = 3,
			SEPARADO = 4,
			UNIDO = 5
		}
		export interface academy {
			work_id: number;
			co_id?: string;
			co_name?: string;
			title: string;
			country_id: number;
			state_id?: number;
			descrip?: string;
			init_time: number;
			finish_time?: number;
			is_verify?: boolean;
			type: AcademyType;
			rubros?: string[];
			areas?: number[];
			moneda?: string | "GTQ";
			salary?: number;
			salary_usd?: number;
			credential_id?: string;
			credential_url?: string;
			/** Only for ES */
			years?: number;
			/** Valos que uso en la UI unicamente */
			extra?: { updated?: boolean };
		}

		export interface urls {
			/** type */
			t: number;
			/** body */
			txt: string;
		}

		export enum AcademyType {
			job = 0,
			studie = 1,
			accomp = 2
		}

		export interface geo {
			lon: number;
			lat: number;
		}
		export interface preferences {
			not_looking_job?: boolean;
			no_about?: boolean;
			no_academy?: boolean;
			no_accomp?: boolean;
			no_lang?: boolean;
			no_public?: boolean;
			no_skills?: boolean;
		}
		export interface skills {
			n: string;
			p: number;
		}
		export interface lngs {
			id: number;
			lvl: number;
		}
		export interface last_referrer {
			ts: number;
			txt: string;
		}
		export interface tel {
			code: number;
			phone: string;
		}
		export interface digeduca {
			/** registro de personal (docentes) */
			registro?: string;
			/** Barcode graduandos */
			barcode?: string;
			/** Codigo personal */
			codigo?: string;
			cod_est?: string;
			cod_eval?: string;
			no_boleta?: string;
			cod_alumno?: string;
			cui?: string;
			nom_ciclo?: string;
			cod_nivel?: string;
			year?: number;
			nee?: boolean;
			momento?: string;
			evaluados?: string;
			tipo_evaluacion?: string;
			modalidad?: string;
			admin?: boolean;
		}
		export interface eep {
			id?: string;
			ext?: string;
			car?: number;
			tipo?: number;
			cod_docente?: string;
			programa?: string;
			hospital?: number;
			hospital_str?: string;
			status?: MGST.eep_redactores.status;
			year: number;
			type: number;
			dpi: string;
		}
		export interface cafa {
			dpi: string;
			programa: string;
			nivel_res: string;
			no_recibo?: string;
			paid: boolean;
		}
		export enum type {
			NORMAL = 0,
			DIGEDUCA = 1,
			FCM = 2, // Antes era 0
			CAFA = 4
		}
	}

	export namespace pages {
		export function isPage(s: string) {
			return s.length != 10 && s.length != 16 && !s.includes("-tmp");
		}

		export enum pay_provider {
			stripe = "stripe",
			manual = "manual",
			recurrente = "recurrente"
		}
		export enum employees {
			E0_1 = 1,
			E2_10 = 2,
			E11_50 = 3,
			E51_200 = 4,
			E201_500 = 5,
			E501_1000 = 6,
			E1001_5000 = 7,
			E5001_10000 = 8,
			E1001 = 9
		}
		export type urls = {
			/** type */
			t: number;
			/** body */
			txt: string;
		};
		export enum sector {
			"Empresa publica" = 1,
			"Institucion educativa" = 2,
			"Organizacion gubernamental" = 3,
			"Organizacion sin ánimo de lucro" = 4,
			"Empresa individual" = 5,
			"Empresa privada" = 6,
			"Asociacion" = 7,
			"Agencia de reclutamiento" = 8,
			"Autonomo" = 9
		}
		export interface ats_config {
			id?: string;
			/** Este es el titulo que va en la toolbar */
			title_toolbar?: string;
			/** Imagen que sale en Redes Sociales */
			og_img?: string;
			/** Descripción que se agregar al HTML <meta>, Para SEO */
			descrip_short?: string;
			/** Mensaje que se muestra permanente en la página */
			perm_msg?: string;
			/** Nombre de la página al abrir el intro */
			title: string;
			/** Imagen en vez de texto `title` de la página al abrir el intro */
			title_img?: string;
			/** Slogan de intro */
			slogan: string;
			intro_title?: string;
			intro_img?: string;
			intro_img_dark?: string;
			/** Logo cuadrado o rectangular */
			logo: string;
			/** Logo cuadrado o rectangular */
			logo_dark?: string;
			/** Logo que se usa en contextos redondos */
			logo_round: string;
			/** Logo que se usa en contextos redondos */
			logo_round_dark?: string;
			/** Favico */
			favicon: string;
			mode: "ats" | "assessments";
			// Colores de la página
			/** Color principal de la página */
			app_color: string;
			primary: string;
			on_primary: string;
			secondary: string;
			on_secondary: string;
			accent: string;
			on_accent: string;
			/** @deprecated */
			dark?: string;
		}

		export interface webhook {
			url: string;
			method: string;
			headers: { [key: string]: string };
		}

		export interface pipeline {
			id: number;
			name: string;
			hired_status?: boolean;
		}

		export enum features {
			psycho_profiles = "psycho_profiles",
			dl_csv = "dl_csv",
			ai_score = "ai_score",
			job_requisition = "job_requisition"
		}

		/*
		Parámetro	Propósito	Ejemplo
		utm_source	¿De dónde viene el tráfico?	google, facebook, newsletter
		utm_medium	¿Cómo llega el tráfico?	cpc, social, email, referral
		utm_campaign	¿Cuál es el nombre de la campaña de marketing?	black_friday, webinar_2024
		utm_term	¿Qué palabra clave atrajo al usuario?	software_rrhh, zapatos_nike
		utm_content	¿Qué versión del contenido generó el clic?	banner_azul, boton_rojo
		*/
		export enum utm_source {
			google = "google",
			facebook = "facebook",
			linkedin = "linkedin",
			x = "x",
			instagram = "instagram",
			youtube = "youtube",
			tiktok = "tiktok",
			newsletter = "newsletter",
			other = "other"
		}
		export enum utm_medium {
			cpc = "cpc",
			cpm = "cpm",
			email = "email",
			organic = "organic",
			paid = "paid",
			referral = "referral"
		}
	}

	export namespace webhooks {
		export enum events {
			JOB_CREATED = "job.created",
			CV_CREATED = "cv.created",
			TEST_FINISHED = "test.finished",
			TEST_FINISHED_DIGEDUCA = "test.finished.digeduca"
		}
		export enum status {
			SUCCEEDED = 0,
			FAILED = 1
		}
	}

	export namespace webservices_api {
		export enum status {
			ACTIVE = "active",
			REVOKED = "revoked"
		}
		export enum scopes {
			USERS_WRITE = "users:write",
			TESTS_ASSIGN = "tests:assign",
			TESTS_READ = "tests:read",
			JOBS_WRITE = "jobs:write",
			JOBS_READ = "jobs:read",
			JOBS_DELETE = "jobs:delete"
		}
	}

	export namespace users_pages {
		export enum rol {
			SUDO = 0,
			ADMIN = 1,
			MEMBER = 2,
			EMPLOYEE = 3,
			EXTERNAL = 4
		}

		export enum status {
			ACTIVE = 0,
			DELETED = 1,
			BLOCKED = 2,
			INVITED = 3,
			REQUESTED = 4,
			PENDING = 5,
			// only frontend
			AUTOJOIN = 6
		}

		export enum permissions {
			// last: 11
			/** =========== <JOBS> =========== */
			SEE_ALL_JOBS = 0,
			CRUD_OWN_JOBS = 6,
			SEE_DASHBOARD = 7,
			SEE_JOBBOARD = 9,
			/** =========== </JOBS> =========== */

			/** =========== <TESTS> =========== */
			/* (Admin) puede ver todo y editar todo */
			ADMIN_TESTS = 1,
			/* Solo los suyos */
			CRUD_SELF_TESTS = 5,
			/** =========== </TESTS> =========== */

			/** =========== <SES> =========== */
			CRUD_OWN_SES = 13,
			SEE_ALL_SES = 12,
			/** =========== </SES> =========== */

			/** =========== <POLY> =========== */
			CRUD_OWN_POLY = 16,
			SEE_ALL_POLY = 15,
			/** =========== </POLY> =========== */

			/** =========== <HEADHUNTING> =========== */
			SEE_ALL_HEADHUNTING = 10,

			CRUD_OWN_HEADHUNTING = 11,
			/** =========== </HEADHUNTING> =========== */

			/** =========== <JOB REQUEST> =========== */
			/**
			 * Crear requisiciones de empleo
			 * Ver sus requisiciones de empleo creadas
			 * Control total para editarlas antes de ser aprobadas
			 * Cambio de estado de la requisición */
			JOB_REQUSITION_CRUD = 2,
			/**
			 * Ver sus requisiciones asignadas
			 * Cambio de estado de la requisición */
			JOB_REQUSITION_ASSIGNED = 3,
			/**
			 * Ver todos las requisiciones de empleo */
			JOB_REQUSITION_ADMIN = 4,
			/**
			 * Ver todos las requisiciones de empleo de sedes */
			SEE_LOCATIONS_REQUESTS = 8,
			/** =========== </JOB REQUEST> =========== */

			/** =========== <MESSAGES> =========== */
			MESSAGES_ADMIN = 17,
			MESSAGES_SEE_OWN = 18,
			MESSAGES_CREATE_OWN = 19,
			MESSAGES_DELETE_OWN = 20,
			/** =========== </MESSAGES> =========== */

			/** =========== <Medical> =========== */
			MEDICAL_ADMIN = 21,
			MEDICAL_SEE_OWN = 22,
			MEDICAL_CREATE_OWN = 23,
			MEDICAL_DELETE_OWN = 24,
			/** =========== </Medical> =========== */

			TIME_ATTENDANCE_ADMIN = 25
		}

		export namespace permissionsSet {
			// last: 9
			/** =========== <JOBS> =========== */
			export const JOBS = [
				PGST.users_pages.permissions.SEE_ALL_JOBS,
				PGST.users_pages.permissions.CRUD_OWN_JOBS,
				PGST.users_pages.permissions.SEE_DASHBOARD,
				PGST.users_pages.permissions.SEE_JOBBOARD
			];
			export const TESTS = [PGST.users_pages.permissions.ADMIN_TESTS, PGST.users_pages.permissions.CRUD_SELF_TESTS];

			export const PSYCHO = [PGST.users_pages.permissions.ADMIN_TESTS, PGST.users_pages.permissions.CRUD_SELF_TESTS];
		}
	}

	export namespace jobs_tests {
		export type options = {
			text: string;
			value: number;
			hidden?: boolean;
		};
	}
	export namespace jobs {
		export enum automation2_auto_test {
			greater_than = 0,
			greater_than_or_equal_to = 1,
			less_than = 2,
			less_than_or_equal_to = 3,
			equal_to = 4
		}
		export interface automation2 {
			stage: number;
			auto: {
				type: "test" | "message" | "interview" | "ses" | "poly";
				/**
				 * type: "test"
				 * tests es un array de tests que se deben pasar para mover al siguiente stage.
				 */
				tests?: {
					/** ID del Test */
					tid: number;
					/** Tipo de comparación */
					gtlt?: automation2_auto_test;
					/** Valor de comparación */
					target: number;
				}[];
				/**
				 * type: "ses | poly"
				 */
				provider_id?: string;
				/**
				 * type: "test"
				 * Phase al que se debe mover el usuario.
				 */
				move_to?: number;
				/**
				 * type: "test" | "message" | "interview"
				 * ## type: "test":
				 * Mensaje que se debe enviar al usuario al moverlo de Phase luego de validar si cumplió con el `target` de los tests.
				 * ## type: "message":
				 * Mensaje que se debe enviar al usuario cuando ingresa a esta phase.
				 * ## type: "interview":
				 * Mensaje que se le enviará al entrevistador que se le asignará a la entrevista.
				 */
				message?: string;

				/**
				 * type: "interview"
				 * Interviews IDs a las que se debe asignar a un miembro de mi equipo
				 * ```typescript
				 * let [rsp, err] = await apiv2.interviews.getAllInterviews(pgInfo.id, this.job.job_id, pgInfo.token);
				 * ```
				 */
				interviews?: PGSchema.interviews["id"][];
				/**
				 *
				 * type: "interview"
				 * Usuarios IDs a los que se debe asignar a un miembro de mi Team(`await window.app.pages.getTeam()`).
				 *
				 * @see ../../../@components/ct/Pages.js
				 */
				interviewers?: PGSchema.users["id"][];

				// ------------------------------------------------------------
				/**
				 * type: "test" | "message" | "interview"
				 * Notifico a los usuario que son miembros de mi equipo que ha ocurrido esta automatización.
				 */
				notify_to?: { uid?: string; email?: string }[];
			}[];
		}
		export interface geo {
			lat: number;
			lon: number;
		}
		export enum domains {
			EMPLEO_GT = 1, // Conectate
			EMPLEOSLATAM = 2,
			GOOGLE_JOBS = 3,
			MY_JOB_SITE = 4
		}
		export enum type {
			PUBLIC = 1, // Empleo completp
			INTERNAL = 2, // Solo empleo con automatización
			JOBBOARD = 3, // Bolsa de empleo
			TEMPLATE = 4, // Template de empleo
			LINK = 5 // Link de empleo
		}
		export enum status {
			OPEN = 0,
			CLOSED = 1,
			DRAFT = 2,
			REQUISITION = 3
		}
		export enum modality {
			PRESENTIAL = 0,
			REMOTE = 1,
			HYBRID = 2
		}
		export interface ruser {
			_id: string;
			name: string;
			email: string;
		}
		export interface anchorage {
			profile?: string;
			report?: string;
			interview?: string;
		}

		export interface langs {
			lang_id: number;
			lvl: number;
		}

		export interface pipeline {
			id: number;
			name: string;
			hired_status?: boolean;
		}
		/**
		 * Tipo de trabajo (work_type)
			● 1 Tiempo Completo
			● 2 Medio tiempo
			● 3 Turnos Rotativos
			● 4 Desde casa
		 */
		export enum work_type {
			full_time = 1,
			part_time = 2,
			rotative = 3,
			internship = 4
		}
		/**
		Tipo de contrato (type_contract)
			● 1 Contrato por tiempo determinado
			● 2 Contrato por tiempo indeterminado
			● 3 Contrato de obra o proyecto
			● 4 Contrato de aprendizaje
			● 5 Otro tipo de contrato
			● 6 Contrato de labor
		*/
		export enum type_contract {
			fixed_term = 1,
			indeterminate = 2,
			project = 3,
			apprenticeship = 4,
			other = 5
		}
		export enum gender {
			MALE = "m",
			FEMALE = "f",
			INDIFERENT = "-"
		}
		export enum domains {
			ct = 1, // Conectate
			ats = 2 // ATS, empleo.gt, custom domain
		}
		export interface ruser {
			_id: string;
			name: string;
			email: string;
		}
		export enum req_in_cv {
			pp = "pp",
			edu = "edu",
			birthday = "bday",
			country = "cntry",
			state = "stt",
			city = "cty",
			skills = "sklls",
			about_me = "about",
			gender = "gndr",
			langs = "langs",
			dpi = "dpi",
			email = "email",
			tel = "tel",
			cv = "cv"
		}
		export interface ai_report {
			candidates: {
				id: string;
				name: string;
				role: string;
				location: string;
				experience: number;
				education: string;
				avatar: string;
				overallScore: number;
				technicalSkills: number;
				culturalFit: number;
				communication: number;
				skills: {
					name: string;
					level: number;
				}[];
				strengths: string[];
				weaknesses: string[];
				isRecommended?: boolean;
			}[];
			recommendation: {
				recommendedCandidateId: string;
				recommendedCandidateName: string;
				confidence: number;
				reasons: string[];
				concerns: string[];
				nextSteps: string[];
				summary: string;
			};
		}
		export interface approved_by {
			requested_by: string;
			requested_at: number;
			approved_by: string;
			approved_at?: number;
			status: "pending" | "approved" | "rejected";
		}
		export interface request_comments {
			uid: string;
			ts: number;
			comment: string;
			file_url?: string;
		}

		export function computePhaseName(pipeline: { id: number; name: string }[] | undefined, moveto: number) {
			// let strings = getStrings("en");
			if (pipeline == undefined || pipeline.length == 0) {
				pipeline = [strings.new_candidates, strings.contacted, strings.interview, strings.in_process, strings.finalist].map((_, i) => ({ id: i, name: _ }));
			}
			switch (moveto) {
				case -1:
					return strings.ended_process;
				default:
					return `${pipeline.find(_ => _.id == moveto)?.name || ""} (${moveto + 1}/${pipeline.length})`.trim();
			}
		}
	}
	export namespace users_jobs {
		export enum type {
			JOBS = "j",
			HEADHUNTING = "hh",
			JOBBOARD = "jb",
			INTERNSHIP = "is"
		}
		export interface time_in_phase {
			s: number;
			t?: number;
		}
	}
	export namespace pages_users_activity {
		export enum type {
			APPLIED = 0,
			VIEWED = 1,
			MOVED_TO_PHASE = 2,
			SEND_TEST = 3,
			SEND_MESSAGE = 4
		}
	}
	export namespace tests {
		export const adminID = "-KzZYgMqxZ4T";

		export enum type {
			NORMAL = 0,
			CLEAVER = 1,
			OTIS = 2,
			OTIS_GAMMA = 3,
			WONDERLIC = 4,
			_16PF = 5,
			TERMAN = 6,
			DOMINOS = 7,
			MOSS = 8,
			KOSTICK = 9,
			IPV = 10,
			MBTI = 11, // MYERS_BRIGGS
			ZAVIC = 12,
			LIFO = 13,
			ALLPORT = 14,
			RAVEN = 15,
			// Testing stage
			GORDON = 16,
			BFQ = 17,
			CE = 18,

			// PMA
			PMA_VERBAL = 19,
			PMA_ESPACIAL = 20,
			PMA_MECANICO = 21,
			PMA_NUMERICO = 22,
			PMA_ABSTRACTO = 23,
			PMA_VELOCIDAD = 24,
			// specific
			TYPING = 25,
			INTEGRITY = 26,
			ENGLISH = 27,
			NEO_PIR = 28,
			// COMPETENCIES
			PPC_G = 29,
			PPC = 30,
			// INTELIGENCIA EMOCIONAL
			IE = 31,
			// LATERALIDAD CEREBRAL
			LAT_CEREBRAL = 32,

			/** Orientación Vocacional, Intereses de estudio */
			OVIE = 33,

			// SAT
			ORTOGRAFIA = 34,
			OFIMATICA = 35,
			IM = 36, // INTELIGENCIAS MULTIPLES
			ENGLISH_LEVEL = 37,
			IV = 38, // INTERESES VOCACIONALES
			MARKETING = 39,
			PRIMEROS_AUXILIOS = 40,
			CONTABILIDAD_I = 41,
			CONTABILIDAD_II = 42,
			FINANZAS = 43,
			BENDER = 44,

			/** Remote Readiness Assessment */
			REMOTE_READINESS = 45,
			/** Clima Laboral */
			WORK_ENV = 46,
			INTEGRITY_PRO = 47
		}

		export enum tid {
			CLEAVER = 1,
			OTIS = 2,
			OTIS_GAMMA = 3,
			WONDERLIC = 4,
			_16PF = 5,
			TERMAN = 6,
			DOMINOS = 7,
			MOSS = 8,
			KOSTICK = 9,
			IPV = 10,
			MBTI = 11, // MYERS_BRIGGS
			ZAVIC = 12,
			LIFO = 13,
			ALLPORT = 14,
			RAVEN = 15,
			// Testing stage
			GORDON = 16,
			BFQ = 17,
			CE = 18,

			// PMA
			PMA_VERBAL = 19,
			PMA_ESPACIAL = 20,
			PMA_MECANICO = 21,
			PMA_NUMERICO = 22,
			PMA_ABSTRACTO = 23,
			PMA_VELOCIDAD = 24,
			// specific
			TYPING = 25,
			TYPING_ES = 1810465,
			INTEGRITY = 26,
			ENGLISH = 27,
			NEO_PIR = 28,
			// COMPETENCIES
			PPC_G = 29,
			PPC = 30,
			// INTELIGENCIA EMOCIONAL
			IE = 31,
			// LATERALIDAD CEREBRAL
			LAT_CEREBRAL = 32,

			/** Orientación Vocacional, Intereses de estudio */
			OVIE = 33,

			// SAT
			ORTOGRAFIA = 34,
			OFIMATICA = 35,
			IM = 36, // INTELIGENCIAS MULTIPLES
			SAT_INGLES = 37,
			IV = 38, // INTERESES VOCACIONALES
			MARKETING = 39,
			PRIMEROS_AUXILIOS = 40,
			CONTABILIDAD_I = 41,
			CONTABILIDAD_II = 42,
			FINANZAS = 43,
			BENDER = 44,

			/** Remote Readiness Assessment */
			REMOTE_READINESS = 45,
			/** Clima Laboral */
			WORK_ENV = 46,
			INTEGRITY_PRO = 47
		}
		/** Esto es para llevar el control de que pruebas psico se puede descargar en excel (estoy hay que ir programandolo una en una) */
		export const psycho_can_download = [MGST.test.type.ZAVIC, MGST.test.type.CLEAVER, MGST.test.type.TERMAN, MGST.test.type.IPV, MGST.test.type._16PF];
		export const allPyschoTestTypes = [
			MGST.test.type.CLEAVER,
			MGST.test.type.OTIS,
			MGST.test.type.OTIS_GAMMA,
			MGST.test.type.WONDERLIC,
			MGST.test.type._16PF,
			MGST.test.type.TERMAN,
			MGST.test.type.DOMINOS,
			MGST.test.type.MOSS,
			MGST.test.type.KOSTICK,
			MGST.test.type.IPV,
			MGST.test.type.MBTI,
			MGST.test.type.ZAVIC,
			MGST.test.type.LIFO,
			MGST.test.type.ALLPORT,
			MGST.test.type.RAVEN,
			// INTELIGENCIA EMOCIONAL
			MGST.test.type.IE,
			// LATERALIDAD CEREBRAL
			MGST.test.type.LAT_CEREBRAL,
			MGST.test.type.INTEGRITYX,
			MGST.test.type.PPC_G,
			MGST.test.type.PPC,
			MGST.test.type.PMA_VERBAL,
			MGST.test.type.PMA_ESPACIAL,
			MGST.test.type.PMA_MECANICO,
			MGST.test.type.PMA_NUMERICO,
			MGST.test.type.PMA_ABSTRACTO,
			MGST.test.type.PMA_VELOCIDAD,
			MGST.test.type.NEO_PIR,
			MGST.test.type.BFQ,
			MGST.test.type.CE,
			MGST.test.type.ORTOGRAFIA,
			MGST.test.type.OVIE
		];
		export const allPMATestTids = [
			MGST.test.tid.PMA_ABSTRACTO,
			MGST.test.tid.PMA_ESPACIAL,
			MGST.test.tid.PMA_MECANICO,
			MGST.test.tid.PMA_NUMERICO,
			MGST.test.tid.PMA_VELOCIDAD,
			MGST.test.tid.PMA_VERBAL
		];

		/** Esto se usa para hacer un autoassign y buscar el ownerID de una prueba especial */
		export const SpecialTestID = new Set([
			MGST.test.tid.CLEAVER,
			MGST.test.tid.OTIS,
			MGST.test.tid.OTIS_GAMMA,
			MGST.test.tid.WONDERLIC,
			MGST.test.tid._16PF,
			MGST.test.tid.TERMAN,
			MGST.test.tid.DOMINOS,
			MGST.test.tid.MOSS,
			MGST.test.tid.KOSTICK,
			MGST.test.tid.IPV,
			MGST.test.tid.MBTI,
			MGST.test.tid.ZAVIC,
			MGST.test.tid.LIFO,
			MGST.test.tid.ALLPORT,
			MGST.test.tid.RAVEN, // 15
			MGST.test.tid.GORDON, // 16
			MGST.test.tid.BFQ, // 17
			MGST.test.tid.CE, // 18
			MGST.test.tid.PMA_VERBAL, // 19
			MGST.test.tid.PMA_ESPACIAL, // 20
			MGST.test.tid.PMA_MECANICO, // 21
			MGST.test.tid.PMA_NUMERICO, // 22
			MGST.test.tid.PMA_ABSTRACTO, // 23
			MGST.test.tid.PMA_VELOCIDAD, // 24
			MGST.test.tid.TYPING, // 25
			MGST.test.tid.TYPING_ES, // 1810465
			MGST.test.tid.INTEGRITYX, // 26
			MGST.test.tid.ENGLISH, // 27
			MGST.test.tid.NEO_PIR, // 28
			MGST.test.tid.PPC_G, // 29
			MGST.test.tid.PPC, // 30
			MGST.test.tid.INTELIGENCIA_EMOCIONAL, // 31
			MGST.test.tid.LATERALIDAD_CEREBRAL, // 32
			MGST.test.tid.OVIE, // 33
			MGST.test.tid.ORTOGRAFIA, // 34
			MGST.test.tid.OFIMATICA, // 35
			MGST.test.tid.INTELIGENCIAS_MULTIPLES, // 36
			MGST.test.tid.ENGLISH_LEVEL, // 37
			MGST.test.tid.INTERESES_VOCACIONALES, // 38
			MGST.test.tid.MARKETING, // 39
			MGST.test.tid.PRIMEROS_AUXILIOS, // 40
			MGST.test.tid.CONTABILIDAD_I, // 41
			MGST.test.tid.CONTABILIDAD_II, // 42
			MGST.test.tid.FINANZAS, // 43
			MGST.test.tid.BENDER, // 44
			MGST.test.tid.REMOTE_READINESS, //45
			// MGST.test.tid.WORK_ENV //46 Esta no porque es por empresa
			MGST.test.tid.INTEGRITYX_PRO //47
		]);
		export const allPsycoTest = [
			MGST.test.tid.CLEAVER,
			MGST.test.tid.OTIS,
			MGST.test.tid.OTIS_GAMMA,
			MGST.test.tid.WONDERLIC,
			MGST.test.tid._16PF,
			MGST.test.tid.TERMAN,
			MGST.test.tid.DOMINOS,
			MGST.test.tid.MOSS,
			MGST.test.tid.KOSTICK,
			MGST.test.tid.IPV,
			MGST.test.tid.MBTI,
			MGST.test.tid.ZAVIC,
			MGST.test.tid.LIFO,
			MGST.test.tid.ALLPORT,
			MGST.test.tid.RAVEN,
			MGST.test.tid.GORDON,
			MGST.test.tid.BFQ,
			MGST.test.tid.CE,
			// INTELIGENCIA EMOCIONAL
			MGST.test.tid.INTELIGENCIA_EMOCIONAL,
			// LATERALIDAD CEREBRAL
			MGST.test.tid.LATERALIDAD_CEREBRAL
		];

		export enum preferences {
			SHOW_REALTIME_RESULTS = 1,
			FEEDBACK_RESULTS = 2,
			RANDOM_QUESTIONS = 3,
			WEBCAM_REQUIRED = 4,
			ONLY_DESKTOP = 5,
			SHARE_SCREEN_REQUIRED = 6,
			DPI_PHOTO = 7,
			NO_PERSONAL_INFO = 8,
			SKIP_QUESTIONS = 9,
			ENHANCED_MONITORING = 10,
			MONITOR = 11,
			HEADSHOT_REQUIRED = 12,
			HIDE_COMPANY = 13,
			ONLY_APP = 14
		}

		export namespace cameras {
			export enum n {
				"facetime" = "facetime",
				"front" = "front",
				"web" = "web",
				"integrated" = "integrated",
				"truevision" = "truevision",
				"hp wide" = "hp wide",
				"hd camera" = "hd camera",
				"hc camera" = "hc camera",
				"facecam" = "facecam",
				"logitec" = "logitec"
			}
		}

		export namespace groups {
			export namespace questions {
				export enum types {
					SELECCION_MULTIPLE = 1,
					SELECCION_UNICA = 2,
					ELECCION_IMG = 3,
					ELECCION_IMG_MULTI = 4,
					RESP_CORTA = 6,
					RESP_LARGA = 7,
					ESCALA_OPINION = 8,
					ARCHIVO = 9,
					VOZ = 10,
					SI_NO = 11,
					FECHA = 12,
					RESPUESTA_EXACTA = 13,
					RESPUESTAS_EXACTAS = 14,
					MAS_MENOS = 15,
					TEL = 16,
					/** Se usa en Zavic y en Allport */
					COMPLETE_INPUT = 17,
					ELECCION_AUDIO = 18,
					TYPING = 19,
					MULTI_YES_NO = 20,
					COMPLETE_INPUT_V2 = 21,
					VIDEO = 22
				}
			}
		}
		export type rules = {
			can_repeat?: boolean;
			/** Cuando es con checkbox */
			max_correct?: number;
			answer?: {
				type: "number" | "text";
				/** Solo aplica cuando es type:number */
				min?: number;
				/** Solo aplica cuando es type:number */
				max?: number;
				title?: string;
			};
		};
		/** @deprecated */
		export namespace digeduca {
			export enum tipo {
				Rotativo = 1,
				Ancla = 2,
				Piloto = 3
			}
			export const componente = [
				//  mate
				"none",
				"Formas, patrones y relaciones", // 1,
				"La incertidumbre, la comunicación y la investigación", // 2,
				"Matemática, ciencia y tecnología", // 3,
				"Sistemas numéricos y operaciones", // 4,
				//lenguaje
				"Comprensión lectora", // 5,
				"Comunicación", // 6,
				"Morfología y sintaxis", // 7,
				"Redacción", // 8,
				// estrategias
				"Atención a estudiantes con Necesidades Educativas Especiales y Psicología", // 9,
				"Estrategias de enseñanza y aprendizaje", // 10,
				"Introducción a la pedagogía", // 11,
				"Introducción al diseño curricular", // 12,
				"Planificación y evaluación del aprendizaje" // 13
			];
		}

		export interface groups {
			_id: string;
			title: string;
			descrip?: string;
			i18n?: { [key: string]: { title: string; descrip: string } };
			preferences?: MGST.test.preferences[];
			questions: TestQuestion[];
		}

		export interface TestQuestion {
			_id: number;
			/** Internal Question ID. Sirve para uso de cada empresa si necesita identificar sus preguntas */
			qid?: string;
			bio?: string;
			question: string;
			descrip?: string;
			i18n?: { [key: string]: { question: string; descrip: string } };
			md?: boolean;
			type: MGST.test.groups.questions.types;
			/** Esto sirve para indicar que las de seleccion multiple al selecionar cualquiera, es correcta */
			any_multi_correct?: boolean;
			required: boolean;
			calc?: boolean;
			/** Para habilitar un espacio en el puede hacer anotaciones durante la pregunta */
			annotations?: boolean;
			/** Pregunta Condicional */
			conditional?: boolean;
			audio?: string;
			img?: string;
			// -------------- VIDEO --------------
			video?: string;
			interview_video_max_time?: number;
			video_thinking_time?: number;
			retake?: number;
			// -------------- /VIDEO --------------
			tags?: string[]; // Solo se usa cuando es tipo 8 (ESCALA_OPINION), Siempre de tamaño 3
			min?: number;
			max?: number;
			solve?: boolean; // se usa solo para GroupsComplete
			skip?: boolean; // se usa solo para GroupsComplete
			rules?: MGST.test.rules | null;
			// Integrity
			type_integrity?: number;
			// Prueba Inteligencia Emocional - Generic type
			type_answer?: number;
			/** Tiempo en segundos que se tardo en contestar */
			time?: number;
			/** Hora a la que contestó la pregunta */
			answered_at?: number;
			answers: TestAnswers[];
		}
		export interface TestAnswers {
			id?: number;
			text: string;
			i18n?: { [key: string]: string }; // { es: "Respuesta en español", en: "Answer in english", pr: "Resposta em português" }
			/** Si es true, es la opcion correcta selecionada */
			correct?: boolean;
			// Fork
			jump?: number;
			/** COMPLETE_INPUT_V2 */
			t21?: {
				/** Escribe el texto de la respuesta correcta */
				correct: string;
			};
			/** Timestamp de FECHA */
			t12?: number;
			// Integrity - Valor por cada respuesta
			value?: string | number;
		}
	}

	export namespace tests_complete {
		export type score_t17 = {
			pts: number;
			pts_pos: number[];
			pts_neg: number[];
		};
		export type score_t1000 = {
			wpm: number;
			os: string;
			correct: number;
			incorrect: number;
			keystrokes: number;
		};
		export type schedule = {
			s: number;
			f: number;
		};
		export type cameras = {
			/** Nombre de la camara */
			n: string;
			/** Si fue esta la que uso */
			u: boolean;
		};
		export type header = {
			// Puesto | Empresa | Reclutador | Email | Edad | Genero | DPI
			/** Position */
			post?: string;
			/** Company name */
			company?: string;
			/** Recliuter name */
			recruiter?: string;
			/** Candidate Email */
			email?: string;
			/** Computed Candidate Age. Ej: 27 */
			age?: string;
			/** Gender */
			gender?: boolean;
			/** CUI */
			dpi?: string;
			/** Candidate name */
			name?: string;
		};
		export enum complete_msg {
			foul = "foul",
			foul_by_monitor = "foul_by_monitor",
			onblur = "onblur",
			already_complete = "202",
			ok = "ok",
			allok = "allok",
			doing = "doing",
			timeout = "timeout",
			timeover = "timeout2"
		}

		export interface attempts_history {
			s: number;
			f: number;
		}

		export interface monitoring {
			ip?: string;
			id?: string;
			browser: any;
			geo: { lat: number; lon: number };
		}

		export interface groups {
			_id: string;
			title?: string;
			descrip?: string;
			correctAnswers: PGST.tests.TestQuestion[];
			complete: boolean;
		}
	}

	export namespace tracking {
		export enum type {
			SEND_TEST = "send_test",
			SEND_MESSAGE = "send_message",
			POST_JOB = "post_job"
		}
	}
	export namespace products {
		export const IDS = {
			basic_mensual: { product_id: 1, price_id: 1 },
			basic_anual: { product_id: 1, price_id: 2 },
			pro_mensual: { product_id: 2, price_id: 3 },
			pro_anual: { product_id: 2, price_id: 4 },
			expert_mensual: { product_id: 3, price_id: 5 },
			expert_anual: { product_id: 3, price_id: 6 }
		};
		export enum products {
			/**
			 * Publicación de empleos
			 * Creación del ATS con la marca de la empresa
			 */
			jobs = 0,
			/**
			 * Acceso a pruebas psicometricas
			 */
			psycho = 1,
			/**
			 * Acceso a requisiciones de empleo
			 */
			job_request = 2,
			/**
			 * Acceso a estudios socioeconómicos
			 */
			ses = 3,
			/**
			 * Acceso a módulo de polígrafos
			 */
			poly = 4,
			/**
			 * Acceso a su bolsa de empleo
			 */
			jobboard = 5,
			/**
			 * Acceso a headhunting
			 */
			headhunting = 6,
			/**
			 * Acceso a intercambiar mensajes con candidatos
			 */
			messages = 7,
			/**
			 * Acceso a pruebas personalizadas
			 */
			tests = 8,
			/**
			 * Acceso a modulo de entrevistas estructuradas
			 */
			interviews = 9,
			/**
			 * Acceso a modulo de entrevistas video
			 */
			video_interviews = 10,
			/**
			 * Acceso a pruebas de integridad
			 * */
			integrity = 11,
			/**
			 * Acceso a modulo de examen médico
			 */
			medical = 12,
			/**
			 * HCM - Operations (time tracking, shift projects, payroll)
			 */
			hcm_operations = 13,
			/**
			 * HCM - finance (Workforce, sales, spending, treasury, accounting)
			 */
			hcm_finance = 14
		}
	}
	export namespace product_prices {
		export enum currency {
			USD = "USD",
			GTQ = "GTQ",
			EUR = "EUR"
		}
		export enum frequency {
			day = "day",
			week = "week",
			month = "month",
			year = "year",
			once = "once"
		}
	}
	export namespace subscriptions {
		export enum status {
			active = "active",
			canceled = "canceled",
			incomplete = "incomplete",
			incomplete_expired = "incomplete_expired",
			past_due = "past_due",
			paused = "paused",
			trialing = "trialing",
			unpaid = "unpaid",
			// Custom
			pending = "pending",
			payment_failed = "payment_failed"
		}
		export enum cancel_reason {
			payment_failed = "payment_failed",
			other = "other"
		}
	}

	export namespace invoices {
		export enum status {
			void = "void",
			paid = "paid",
			upgrade = "upgrade",
			courtesy = "courtesy"
		}
	}

	export namespace sub_used_details {
		export enum kind {
			/** Plan */
			test = 0,
			/** Job */
			job = 1,
			/** Test */
			psycho = 2,
			/** Pruebas de integridad */
			integrity = 3,
			/** Interview */
			interview = 4,
			/** video interview */
			video_interview = 5
		}
	}

	export namespace notifications {
		export interface body {
			// A01_WELCOME_RECRUITER
			a01?: {
				profile_name: string;
				ats_url: string;
				ats_name: string;
			};
			// A02_CREATE_NEW_PAGE
			a02?: {
				user_name: string;
				page_name: string;
				username: string;
				activation_link: string;
			};
			a03?: {
				subscription_name: string;
				plan_name: string;
				status: string;
			};
			// --------------------------------------------------------------------
			t00?: {
				msg: string;
				plain?: string;
				subject?: string;
			};
			// t01_WELCOME_ACCOUNT
			t01?: {
				profile_name: string;
				ats_url: string;
				ats_name: string;
			};
			t02?: {
				profile_name: string;
				ats_url: string;
				ats_name: string;
			};

			t05?: {
				job_name: string;
				phase: string;
				msg?: string | null;
			};
			/** ID de rubros de interes a filtrar al llegar al job finder */
			t06?: string[];
			t11?: {
				sender: string;
				msg: string;
			};
			t13?: {
				by: string;
				profilename: string;
				comment: string;
			};
			t14?: {
				phase: string;
				candidate_name: string;
				dpi: string;
			};
			// New Pyscho test
			t15?: /* t16 */ {
				origin: string;
				company: string;
				test_ttl: string;
				msg?: string | null;
				type: MGST.test.type | PGST.tests.type;
				link: string;
			};
			t16?: /* t16 */ {
				origin: string;
				company: string;
				test_ttl: string;
				msg?: string | null;
				type: MGST.test.type | PGST.tests.type;
				link: string;
			};
			t17?: {
				name: string;
				stage: string;
			};
			t18?: {
				name: string;
				test_ttl: string;
			};
			t19?: {
				company: string;
			};
			// _20_INVITE_TO_JOIN_TEAM
			t20?: {
				coname: string;
				issuer_name: string;
				issuer_email: string;
				thumb: string;
				pgid: string;
				username: string;
			};
			// _21_RESOLVE_INTERVIEW
			t21?: {
				pgid: PGSchema.pages["id"];
				user_name: string;
				uid: string;
				interviews: { iid: string; inter_title: string; assigned_id: string; user_name: string; cv_link: string }[];
				msg?: string;
			};
			/** [email] OTP */
			t22?: {
				code: number;
			};
			t23?: {
				page_name: string;
				user_name: string;
				link: string;
			};
			t24?: {
				page_name: string;
				user_name: string;
				link: string;
			};
			t25?: {
				user_name: string;
				position: string;
				link: string;
			};
			t26?: {
				user_name: string;
				position: string;
				link: string;
				phase: string;
			};
			t27?: {
				user_name: string;
				position: string;
				link: string;
			};
			t28?: {
				user_name: string;
				position: string;
				link: string;
			};
			t29?: {
				requester_name: string;
				approver_name?: string;
				start_date: string;
				end_date: string;
				total_days: number;
				status: "pending" | "approved" | "rejected";
				request_type: string;
			};
			t30?: {
				review_title: string;
				reviewer_name: string;
				end_date: string;
				/** Present when event = "subject_completed" */
				subject_name?: string;
				/** "assigned" (default) | "subject_completed" */
				event?: "assigned" | "subject_completed";
			};
		}

		export enum types {
			/** channels: email */
			/** channels: email */
			A01_WELCOME_RECRUITER = "a01",
			A02_CREATE_NEW_PAGE = "a02",
			A03_SUBSCRIPTION_PAYMENT_FAILED = "a03",
			T0_GENERIC = "00",
			T01_WELCOME_CANDIDATE_ACCOUNT = "01",
			T5_CHANGE_JOB_PHASE = "05",
			/** channels: timeline, push, email */
			T6_NEW_JOB_OFFERS = "06",
			/** channels: push, email */
			T11_MESSAGE = "11",
			/** channels: "push", "timeline" */
			T13_PRIVATE_PROFILE_COMMENTS = `13`,
			T14_SES_NEXT_PHASE = `14`,
			/** channels" "timeline", "push", "email" */
			T15_PYSCO_NEW_TEST = `15`,
			T16_NEW_TEST = `16`,
			T17_CANDIDATE_MOVE_TO_PHASE = `17`,
			T18_CANDIDATE_COMPLETE_ASSESSMENT = `18`, // [CandidateName, PaseMove],
			T19_SUBSCRIPTION_RENEWAL = `19`,
			T20_INVITE_TO_JOIN_TEAM = `20`,
			T21_RESOLVE_INTERVIEW = `21`,
			T22_OTP = `22`,
			T23_SEND_SES = `23`,
			T24_SEND_POLY = `24`,
			T25_UPDATE_SES_LINK = `25`,
			T26_UPDATE_SES_PHASE = `26`,
			T27_UPDATE_POLY_LINK = `27`,
			T28_UPDATE_MEDICAL_LINK = `28`,
			T29_TIME_OFF_REQUEST = `29`,
			/** channels: timeline, push, email */
			T30_PERFORMANCE_REVIEW = `30`
		}
		/** This is to add List-ID headers in email */
		export function typesToString(types: PGST.notifications.types): string {
			switch (types) {
				case PGST.notifications.types.A01_WELCOME_RECRUITER:
					return "a01_welcome_recruiter";
				case PGST.notifications.types.A02_CREATE_NEW_PAGE:
					return "a02_create_new_page";
				case PGST.notifications.types.T0_GENERIC:
					return "0_generic";
				case PGST.notifications.types.T01_WELCOME_CANDIDATE_ACCOUNT:
					return "a01_welcome_account";
				case PGST.notifications.types.T5_CHANGE_JOB_PHASE:
					return "5_change_job_phase";
				case PGST.notifications.types.T6_NEW_JOB_OFFERS:
					return "New Jobs";
				case PGST.notifications.types.T11_MESSAGE:
					return "11_message";
				case PGST.notifications.types.T13_PRIVATE_PROFILE_COMMENTS:
					return "13_private_profile_comments";
				case PGST.notifications.types.T14_SES_NEXT_PHASE:
					return "14_ses_next_phase";
				case PGST.notifications.types.T15_PYSCO_NEW_TEST:
					return "15_pysco_new_test";
				case PGST.notifications.types.T16_NEW_TEST:
					return "16_new_test";
				case PGST.notifications.types.T17_CANDIDATE_MOVE_TO_PHASE:
					return "17_candidate_move_to_stage";
				case PGST.notifications.types.T18_CANDIDATE_COMPLETE_ASSESSMENT:
					return "18_candidate_complete_assessment";
				case PGST.notifications.types.T19_SUBSCRIPTION_RENEWAL:
					return "19_subscription_renewal";
				case PGST.notifications.types.T20_INVITE_TO_JOIN_TEAM:
					return "20_invite_to_join_team";
				case PGST.notifications.types.T21_RESOLVE_INTERVIEW:
					return "21_resolve_interview";
				case PGST.notifications.types.T25_UPDATE_SES_LINK:
					return "25_update_ses_link";
				case PGST.notifications.types.T26_UPDATE_SES_PHASE:
					return "26_update_ses_phase";
				case PGST.notifications.types.T27_UPDATE_POLY_LINK:
					return "27_update_poly_link";
				case PGST.notifications.types.T28_UPDATE_MEDICAL_LINK:
					return "28_update_medical_link";
				case PGST.notifications.types.T29_TIME_OFF_REQUEST:
					return "29_time_off_request";
				case PGST.notifications.types.T30_PERFORMANCE_REVIEW:
					return "30_performance_review";
				default:
					return `${types}-type`;
			}
		}
	}
	export namespace rooms {
		export interface read_by {
			uid: string;
			ts: bigint | number;
		}
	}
	export namespace room_msg {
		export interface m {
			/** Title */
			t: string;
			/** Message */
			m?: string;
			/** Imagenes */
			i?: string[];
		}
	}

	export namespace email_activity {
		export enum status {
			COMPLAINED = -2,
			BOUNCED = -1,
			SENT = 0,
			DELIVERED = 1,
			OPENED = 2,
			CLICKED = 3
		}
	}

	export namespace gallery {
		export enum type {
			IMAGE = 0,
			AUDIO = 1,
			VIDEO = 2,
			PDF = 3
		}
	}

	export namespace interviews {
		export interface questions {
			id: number;
			order: number;
			title: string;
			skill_id?: PGSchema.interview_skills["id"];
			labels?: string[];
		}

		export enum type {
			STRUCTURED = "structured",
			FORM = "form"
		}

		export type questions_form = TestQuestion;
	}
	export namespace interviews_assigned {
		export interface questions_form {
			uid: string;
			qid: number;
			answer?: string;
			answers?: number[];
		}
		export interface questions {
			uid: string;
			qid: number;
			score: number;
			notes?: string;
			skill_id?: PGSchema.interview_skills["id"];
		}
		export interface tmp_interviewers {
			id: string;
			name: string;
			email: string;
			status: "completed" | "pending";
			comment?: string;
			created_at?: Date | string;
			updated_at?: Date | string;
		}
	}

	export namespace set_of_assessments {
		export interface tests {
			tid: number;
			title: string;
			options: {
				text: string;
				value: string | number;
				tooltip?: string;
				active: boolean;
			}[];
			min: number;
			max: number;
			step: number;
		}
	}

	export interface assistant_history {
		role: "user" /* Gemini */ | "system" /* Gemini */ | "assistant" /* Gemini */ | "model" /* ChatGPT */;
		parts: { text: string }[];
	}

	export namespace page_logs {
		export enum type {
			ASSIGN_TEST = "assign_test",
			DELETE_TEST = "delete_test",
			DELETE_TEST_COMPLETE = "delete_test_complete",
			ASSIGN_INTERVIEW = "assign_interview",
			DELETE_INTERVIEW = "delete_interview",
			ASSIGN_VIDEO_INTERVIEW = "assign_video_interview",
			DELETE_VIDEO_INTERVIEW = "delete_video_interview",
			CREATE_JOB = "create_job",
			DELETE_JOB = "delete_job",
			ADD_USER_TO_PAGE = "add_user_to_page",
			REMOVE_USER_FROM_PAGE = "remove_user_from_page"
		}
		export interface data {
			assign_test?: { tid: number; uids: string[] };
			delete_test?: { tid: number; uids?: string[] };
			delete_test_complete?: { id: string; tid: number; uid?: string; test: any };
			assign_interview?: { iid: string; uids: string[] };
			delete_interview?: { iid: string; uids?: string[] };
			assign_video_interview?: { iid: string; uids: string[] };
			delete_video_interview?: { iid: string; uids?: string[] };
			create_job?: { job_id: number };
			delete_job?: { job_id: number };
			add_user_to_page?: { uid: string };
			remove_user_from_page?: { uid: string };
		}
	}

	export namespace changelog {
		export enum asset_type {
			IMAGE = "image",
			VIDEO = "video",
			PDF = "pdf"
		}
		export interface langs {
			lang: string;
			txt: string;
			bullets?: {
				icon?: icon;
				title: string;
				description: string;
				href?: string;
			}[];
		}
	}

	export namespace users_ses {
		export interface ses {
			complete?: Complete[];
			personal: Personal;
			laboral: Laboral[];
			social: Social[];
			referrer: Referrer;
			family_structure: FamilyStructure;
			economics: Economics;
			housing: Housing;
			annexes?: { name: string; url: string }[];
		}

		export type Complete = "personal" | "laboral" | "social" | "referrer" | "family_structure" | "economics" | "housing" | "opinion";

		export interface Housing {
			home?: { name: string; url: string }[];
			candidate?: { name: string; url: string }[];
			location?: { home: string; photo: string; photo_zoomed: string };
		}

		export interface Economics {
			ingress: Ingress[];
			egress: Egress[];
			living_place: LivingPlace;
			neighborhood: Neighborhood;
			vehicules: Vehicule[];
			bank_commercial_references: BankCommercialReferences;
		}

		export interface BankCommercialReferences {
			accounts: Account[];
			cards: Card[];
		}

		export interface Account {
			bank: string;
			account_type: number;
			amount: number;
			currency: string;
		}

		export interface Card {
			card_type: number;
			bank: string;
			amount: number;
			currency: string;
			credit_limit: number;
			stauts: string;
			time_slow_payer: number;
		}

		export interface Egress {
			type?: number;
			amount?: number;
			contribution?: number;
			currency?: string;
			other?: Other[];
		}

		export interface Other {
			name?: string;
			contribution?: number;
		}

		export interface Ingress {
			type?: number;
			concept?: string;
			salary?: number;
			other_concept?: string;
			other_ingress?: number;
			currency?: string;
		}

		export interface LivingPlace {
			time_to_reside?: number;
			num_people_in_home?: number;
			change_home?: boolean;
			time_to_reside_last?: number;
			reason_to_change?: string;
			home_type?: number;
			rent_cost?: number;
			rent_currency?: string;
			levels?: number;
			style?: string;
			material?: string;
			furniture?: string;
			floor?: string;
			services?: string;
			comparition_neighboring_homes?: string;
			home_external_condition?: string;
			home_internal_condition?: string;
		}

		export interface Neighborhood {
			social_lvl?: string;
			public_transp?: string;
			police_zone_type?: string;
		}

		export interface Vehicule {
			brand?: string;
			model?: string;
			plate?: string;
			value?: number;
			currency?: string;
		}

		export interface FamilyStructure {
			father: FamilyMember;
			mother: FamilyMember;
			brothers: FamilyMember[];
			mate: FamilyMember[];
			sons: FamilyMember[];
			observations: string;
		}

		export interface FamilyMember {
			name?: string;
			birthday?: number;
			civil_status?: number;
			studies?: number;
			profession?: string;
			where_works?: string;
			sindicato?: string;
			has_been_jail?: boolean;
			salary?: number;
			currency?: string;
			lives_same_house?: boolean;
			how_is_relationship?: string;
		}

		export interface Laboral {
			_id: number;
			co_name: string;
			title: string;
			referrer_request: number;
			init_time: number;
			finish_time: number;
			salary: number;
			currency: string;
			last_salary: number;
			last_currency: string;
			reason_departure: string;
			considered_rehire: boolean;
			informant_name: string;
			informant_position: string;
			observations: string;
			boss_name: string;
			boss_position: string;
			boss_number: string;
			puntuality: number;
			personal_presentation: number;
			conduct: number;
			relationship_superiors: number;
			teamwork: number;
			regulatory_compliance: number;
			performance: number;
			Qualities: string;

			iniciativa: number;
			responsabilidad: number;
			organization: number;
			creativity: number;
			honradez: number;
			honestidad: number;
			autocontrol: number;

			areas_opportunity: string;
			work_pressure: string;
			decision_making: string;
			leadership: string;
			proactivity: string;
			work_without_supervision: string;
			how_many_people_under_your_charge: string;
			it_has_belonged_to_a_union_group: string;
			he_has_sued_the_company: string;
			vices: string;
		}

		export interface Personal {
			general_info: GeneralInfo;
			docs: Docs;
			school: School;
			state_physical_health: IStatePhysicalHealth;
			habits: Habits;
			body_marks: BodyMarks;
			eval_personalidad: EvalPersonalidad;
			eval_labor: EvalLabor;
			aficiones: Aficiones;
		}

		// Generated by https://quicktype.io

		export interface IStatePhysicalHealth {
			height?: number;
			weight?: number;
			tez_color?: string;
			particular_signs?: string;
			eye_color?: string;
			physical_completion?: string;
			chronic_diseases?: string;
			Surgeries?: string;
			Accidents?: string;
			Allergies?: string;
			take_medication?: string;
			special_capac?: string;
			go_to_hostpital_frec?: string;
			when_go_hostpital?: number;
			been_admitted_to_a_hospital?: string;
			some_member_is_missing?: string;
			vision_defect?: string;
			listen_defect?: string;
		}

		export interface Aficiones {
			//section_name: string;
			data: AficionesData;
		}

		export interface AficionesData {
			read?: boolean;
			read_frec?: string;
			movies?: boolean;
			movies_frec?: string;
			music?: boolean;
			music_frec?: string;
			tv?: boolean;
			tv_frec?: string;
			sport?: boolean;
			sport_frec?: string;
			other?: string;
			other_frec?: string;
		}

		export interface BodyMarks {
			//section_name: string;
			data: BodyMarksData;
		}

		export interface BodyMarksData {
			tatto?: boolean;
			tatto_place?: string;
			tatto_measure?: number;
			tatto_meaning?: string;
			earrings?: boolean;
			earrings_place?: string;
			earrings_meaning?: string;
			tallados?: boolean;
			tallados_place?: string;
			tallados_meaning?: string;
		}

		export interface Docs {
			//section_name: string;
			data: DocsData;
		}

		export interface DocsData {
			dpi?: string;
			dpi_extended?: number;
			social_num?: string;
			social_num_verified?: boolean;
			irtra_num?: string;
			driver_lic?: boolean;
			driver_lic_type?: string;
			driver_lic_valid?: number;
			passport?: string;
			passport_valid?: number;
			usa_visa?: string;
			usa_visa_valid?: number;
			nit?: string;
			criminal_record?: string;
			criminal_record_valid?: number;
			criminal_record_verified?: string;
			police_record?: string;
			police_record_valid?: number;
			police_record_verified?: string;
			healt_card?: string;
			healt_card_valid?: number;
			healt_card_verified?: string;
			lungs_card?: string;
			lungs_card_valid?: number;
			lungs_card_verified?: string;
			food_handling?: string;
			food_handling_valid?: number;
			food_handling_verified?: string;
		}

		export interface EvalLabor {
			//section_name: string;
			data: EvalLaborData;
		}

		export interface EvalLaborData {
			stable_job?: boolean;
			describe_worker?: string;
			is_absent_work?: boolean;
			boring_rep_tasks?: boolean;
			how_react_cretics?: string;
			react_objection_ideas?: string;
			offered_bribe?: string;
			counterfeit_work_doc?: string;
			accused_of_theft?: string;
			partic_sindicato?: string;
			opinion_sindicato?: string;
			obj_professional?: string;
			short_term?: string;
			mid_term?: string;
			long_term?: string;
			business_expectation?: string;
		}

		export interface EvalPersonalidad {
			//section_name: string;
			data: EvalPersonalidadData;
		}

		export interface EvalPersonalidadData {
			describe?: string;
			smart_people?: boolean;
			angry_reaction?: string;
			dislike_people?: string;
			what_are_your_values?: string;
			how_face_dislike_tast?: string;
			falsify_doc?: boolean;
			falsify_doc_explain?: string;
			personal_objectives?: string;
			short_term?: string;
			mid_term?: string;
			long_term?: string;
			have_guns?: boolean;
			have_guns_explain?: string;
			has_been_jail?: boolean;
			has_been_jail_explain?: string;
		}

		export interface GeneralInfo {
			//section_name: string;
			data: GeneralInfoData;
		}

		export interface GeneralInfoData {
			name?: string;
			last_name?: string;
			place_born?: number;
			birthday?: number;
			nationality?: number;
			state?: number;
			city?: number;
			nationality_other?: number[];
			civil_status?: number;
			tel?: string[];
			cel?: string[];
			email?: string;
			langs?: Lang[];
			ethnicity?: number;
			blood_type?: string;
			dir?: string;
			profession_area?: number[];
			profession_rubro?: string[];
			collegiate_number?: string;
			religion?: string;
		}

		export interface Lang {
			lang: number;
			lvl: number;
		}

		export interface Habits {
			// section_name: string;
			data: HabitsData;
		}

		export interface HabitsData {
			tobacco?: boolean;
			tobacco_quantity?: string;
			tobacco_frecuency?: string;
			alcohol?: boolean;
			alcohol_quantity?: string;
			alcohol_frecuency?: string;
			drugs?: boolean;
			type?: string[];
			drugs_quantity?: string;
			drugs_frecuency?: string;
			observations?: string;
		}

		export interface School {
			// section_name: string;
			data: SchoolData[];
		}

		export interface SchoolData {
			init_time: number;
			finish_time: number;
			co_name: string;
			career: string;
			areas: number[];
			rubros: string[];
			comprobante: string;
			verified: boolean;
		}

		export interface Referrer {
			personal: Family[];
			neighbors: Family[];
			family: Family[];
			others?: { title: string; text: string }[];
		}

		export interface Family {
			name: string;
			phone: string;
			relationship: string;
			address: string;
			time_to_meet: string;
			positive_aspects: string;
			negative_aspects: string;
			virtues: string;
			success_improvement: string;
			candidate_correct: string;
			why_should_hire: string;
			observations: string;
		}

		export interface Social {
			title: string;
			profile: string[];
			posts: string[];
			observations: string;
		}
	}

	export namespace hcm_attendances {
		export enum mode {
			MANUAL = "manual",
			REALTIME = "realtime",
			EDITED = "edited"
		}
		export enum type {
			WORK = "work",
			BREAK = "break",
			LUNCH = "lunch",
			OTHER = "other"
		}
	}

	export namespace hcm_posts {
		export enum type {
			ANNOUNCEMENT = "Announcement",
			RECOGNITION = "Recognition"
		}
	}

	export namespace hcm_agreements {
		export enum status {
			ONGOING = "ongoing",
			TERMINATED = "terminated",
			OTHER = "other"
		}
		export enum agreement_type {
			CONTRACT = "contract",
			AGREEMENT = "agreement",
			OTHER = "other"
		}
		export enum type {
			INDETERMINATE = "indeterminate",
			FIXED_TERM = "fixed_term",
			PROJECT = "project",
			APPRENTICESHIP = "apprenticeship",
			OTHER = "other"
		}
	}

	export namespace hcm_time_off_requests {
		export enum type {
			HOLIDAYS = "holidays",
			SICK = "sick",
			PERSONAL = "personal",
			OTHER = "other"
		}
		export enum status {
			PENDING = "pending",
			APPROVED = "approved",
			REJECTED = "rejected"
		}
	}

	export namespace hcm_payroll_concepts {
		export enum type {
			EARNING = "earning",
			DEDUCTION = "deduction",
			EMPLOYER_COST = "employer_cost"
		}
		export enum calc_type {
			FIXED_AMOUNT = "fixed_amount",
			PERCENTAGE_BASE = "percentage_base",
			PERCENTAGE_GROSS = "percentage_gross",
			CUSTOM_FORMULA = "custom_formula"
		}
	}

	export namespace hcm_payroll_runs {
		export enum status {
			DRAFT = "draft",
			APPROVED = "approved",
			PAID = "paid",
			CANCELED = "canceled"
		}
	}

	export namespace hcm_performance_reviews {
		export enum status {
			DRAFT = "draft",
			ACTIVE = "active",
			COMPLETED = "completed",
			ARCHIVED = "archived"
		}
		export enum review_types {
			SELF = "self",
			MANAGER = "manager",
			PEER = "peer",
			SUBORDINATES = "subordinates"
		}
		export enum audience {
			Everyone = "everyone",
			Dynamic = "dynamic",
			Custom = "custom"
		}
		export interface filters {
			field: string;
			operator: "in";
			value: string;
		}
		export interface groups {
			id: string;
			name: string;
			description: string;
			type: "self" | "manager" | "peer" | "subordinates";
			questions: {
				id: string;
				name: string;
				description: string;
				type: PGST.hcm_performance_reviews.$groups.question.types;
				answers: {
					id: string;
					name: string;
				}[];
			}[];
		}
		export namespace $groups {
			export namespace question {
				export enum types {
					TEXT_FIELDS = 0,
					STAR = 1,
					LIST = 2
				}
			}
		}
	}

	export namespace hcm_performance_review_subjects {
		export interface action_plan {
			id: string;
			task: string;
			due_date?: string;
			status: "pending" | "in_progress" | "completed";
		}
	}

	export namespace hcm_performance_review_feedbacks {
		export enum role {
			SELF = "self",
			MANAGER = "manager",
			PEER = "peer",
			SUBORDINATES = "subordinates"
		}
		export enum status {
			PENDING = "pending",
			IN_PROGRESS = "in_progress",
			SUBMITTED = "submitted"
		}
		export interface answers {
			group: string;
			question: string;
			answer: string;
			note?: string;
		}
		export interface questions {
			id: string;
			group: "competency" | "general" | "9box";
			name: string;
			description: string;
			type: PGST.hcm_performance_reviews.$groups.question.types;
		}
	}

	export namespace hcm_time_off_policy {
		export enum type {
			FIXED = "fixed",
			OVERTIME = "overtime",
			BY_WORKED = "by_worked"
		}
		export enum absence_types {
			HOLIDAYS = "holidays",
			SICK = "sick",
			PERSONAL = "personal",
			OTHER = "other"
		}
		export enum allowance_type {
			DAYS = "days",
			HOURS = "hours"
		}
		export enum allowance_display_type {
			HALF_N_DAY = "half_n_day",
			DECIMAL = "decimal",
			ROUND_UP = "round_up"
		}
		export enum allowance_day_type {
			WORKING = "working",
			CALENDAR = "calendar"
		}
		export enum available_days {
			ALL_DAYS = "all_days",
			WORKING_DAYS = "working_days",
			GENERATED_DAYS = "generated_days",
			GENERATED_DAYS_MONTHLY = "generated_days_monthly",
			GENERATED_DAYS_MONTHLY_FIRST_DAY = "generated_days_monthly_first_day",
			MONTHLY_FIFTEENTH = "monthly_fifteenth",
			BIMONTHLY_FIRST_AND_FIFTEENTH = "bimonthly_first_and_fifteenth",
			BIMONTHLY_FIFTEENTH_AND_LAST = "bimonthly_fifteenth_and_last"
		}
		export enum accrued_units_availability {
			CURRENT_CYCLE = "current_cycle",
			NEXT_CYCLE = "next_cycle"
		}
		export interface tenure_period {
			amount: number;
			type: "days" | "hours";
			allowance_days: number;
			max_allowance_days?: number;
		}
	}
}
